import React from "react";
import TextField from "@mui/material/TextField";

export const MaskField = ({ formatMask = value => value, onChange, ...rest }) => {
  const handleChange = e => {
    e.target.value = formatMask(e.target.value);
    return onChange && onChange(e);
  }

  return (
    <TextField {...rest} onChange={handleChange} />
  )
}
